import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditRedeemBrand from "../../../components/SuperAdmin/RedeemBrand/EditRedeemBrand";

export default withRouter(connect()(EditRedeemBrand));
